import * as React from 'react';
import { Redirect, withRouter, RouteComponentProps } from 'react-router';

type Props = RouteComponentProps<any> & { to: string };

function RootToFirstStepBase(props: Props) {
    const { to, location } = props;

    if (location.pathname === '/') {
        return <Redirect to={to} />;
    }

    return null;
}

export default withRouter(RootToFirstStepBase);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/router/RootToFirstStepBase.tsx